import { useEffect, useState } from "react";

const SHOW_MS = 4000;

// Chat lines pop out of the speaker's avatar as a speech bubble for 4 s, then fade — the history lives in the chat drawer.
export const ChatBubbles = ({ chat, at, me }) => {
  const [live, setLive] = useState([]);
  const last = chat[chat.length - 1];
  useEffect(() => {
    if (!last || Date.now() - new Date(last.ts).getTime() > SHOW_MS) return undefined;
    setLive((l) => [...l.filter((m) => m.seat !== last.seat), last]); // newest line per seat
    const id = setTimeout(() => setLive((l) => l.filter((m) => m.id !== last.id)), SHOW_MS);
    return () => clearTimeout(id);
  }, [last?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return live.map((m) => {
    const pos = at(m.seat);
    if (!pos) return null;
    const left = parseFloat(pos.left) < 50;
    return (
      <div key={m.id} data-testid={`chat-bubble-${m.seat}`} className={`absolute z-40 pointer-events-none chat-bubble ${left ? "chat-bubble-left" : "chat-bubble-right"}`}
        style={{ left: pos.left, top: pos.top, transform: `translate(${left ? "28px" : "calc(-100% - 28px)"}, calc(-100% - 46px))` }}>
        <div className={`relative max-w-[220px] rounded-2xl px-3.5 py-2 text-sm font-medium leading-snug shadow-[0_8px_24px_rgba(0,0,0,0.55)] border ${m.seat === me ? "bg-amber-300 text-slate-900 border-amber-100" : "bg-slate-50 text-slate-900 border-white"}`}>
          {m.text}
          <span className={`absolute -bottom-2 w-4 h-4 rotate-45 ${m.seat === me ? "bg-amber-300" : "bg-slate-50"} ${left ? "left-3" : "right-3"}`} />
        </div>
      </div>
    );
  });
};
